import { render, staticRenderFns } from "./IncomeTaxInfo.vue?vue&type=template&id=7a93794c&scoped=true&"
import script from "./IncomeTaxInfo.vue?vue&type=script&lang=js&"
export * from "./IncomeTaxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a93794c",
  null
  
)

export default component.exports